import { DepartmentModel } from "@app/catalog";

export class DepartmentNotFoundMessage {
    public department: DepartmentModel;
    
    constructor(department: DepartmentModel)
    {
        this.department = department;
    }
}